import React from 'react';
import PropTypes from 'prop-types';

export default function IconMediation({
  className,
  // style = {}
}) {
  return (
    <svg className={className} fill="none" height="19" viewBox="0 0 19 19" width="19" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.16512 11.4999C8.16512 11.2077 8.21526 10.9272 8.30739 10.6665H2.54203C1.50702 10.6665 0.667969 11.5055 0.667969 12.5406V13.3072C0.667969 13.7839 0.81664 14.2488 1.09328 14.637C2.37841 16.4407 4.48088 17.3341 7.33168 17.3341C7.66298 17.3341 7.98418 17.3221 8.29519 17.2979C8.21084 17.0473 8.16512 16.7789 8.16512 16.4999V11.4999Z" fill="white"/>
      <path d="M7.33168 0.67041C9.63287 0.67041 11.4984 2.53589 11.4984 4.83708C11.4984 7.13826 9.63287 9.00374 7.33168 9.00374C5.0305 9.00374 3.16502 7.13826 3.16502 4.83708C3.16502 2.53589 5.0305 0.67041 7.33168 0.67041Z" fill="white"/>
      <path d="M8.99845 11.4999C8.99845 10.5794 9.74465 9.83321 10.6651 9.83321H16.4985C17.4189 9.83321 18.1651 10.5794 18.1651 11.4999V16.4999C18.1651 17.4204 17.4189 18.1665 16.4985 18.1665H10.6651C9.74465 18.1665 8.99845 17.4204 8.99845 16.4999V11.4999ZM11.0818 12.3332C10.8517 12.3332 10.6651 12.5198 10.6651 12.7499C10.6651 12.98 10.8517 13.1665 11.0818 13.1665H16.0818C16.3119 13.1665 16.4985 12.98 16.4985 12.7499C16.4985 12.5198 16.3119 12.3332 16.0818 12.3332H11.0818ZM11.0818 14.8332C10.8517 14.8332 10.6651 15.0198 10.6651 15.2499C10.6651 15.48 10.8517 15.6665 11.0818 15.6665H16.0818C16.3119 15.6665 16.4985 15.48 16.4985 15.2499C16.4985 15.0198 16.3119 14.8332 16.0818 14.8332H11.0818Z" fill="currentColor"/>
    </svg>

  );
}

IconMediation.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};
